"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    checked?: boolean | 'indeterminate'
  }
>(({ className, checked, ...props }, ref) => {
  // Handle indeterminate state
  const isIndeterminate = checked === 'indeterminate'
  const isChecked = checked === true
  
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      checked={isChecked || isIndeterminate}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[#0F214B] data-[state=checked]:bg-[rgba(15,33,75,0.2)] data-[state=indeterminate]:border-[#0F214B] data-[state=indeterminate]:bg-[rgba(15,33,75,0.2)]",
        className
      )}
      data-state={isIndeterminate ? "indeterminate" : isChecked ? "checked" : "unchecked"}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-[#0F214B]")}
      >
        {isIndeterminate ? (
          <Minus className="h-4 w-4 text-[#0F214B] font-bold" />
        ) : isChecked ? (
          <Check className="h-4 w-4" />
        ) : null}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
